import { gql } from "@apollo/client";

export const GET_CAMPAIGNS = gql`
  query Campaigns($upcomingDays: Int) {
    campaigns(upcomingDays: $upcomingDays) {
      id
      brand {
        id
        name
        lat
        lng
        roadAddr
        instagramUrl
        naverPlaceUrl
      }
      channel
      productName
      category
      originalPrice
      discountPrice
      paybackPrice
      discountRate
      eatingMethods
      productImageUrl
      productUrl
      isPublished
      missionStepCount
      hasSearchMission
      hasLikeMission
      hasPurchaseMission
      hasReviewMission
      nearestRunStartAt
      contract {
        id
        endAt
        monthlyParticipationLimit
        currentUserParticipationCount
        remainingParticipationCount
      }
      runs {
        id
        startAt
        endAt
        depositAmount
        prizeAmount
        isActive
        maxParticipants
        currentParticipants
        isFull
        remainingSlots
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_CAMPAIGN = gql`
  query Campaign($campaignId: Int!) {
    campaign(campaignId: $campaignId) {
      id
      brand {
        id
        name
        lat
        lng
        roadAddr
        instagramUrl
        naverPlaceUrl
        isLiked
      }
      channel
      productName
      category
      originalPrice
      discountPrice
      paybackPrice
      discountRate
      photoReviewRequired
      eatingMethods
      productImageUrl
      productUrl
      isPublished
      missionStepCount
      hasSearchMission
      hasLikeMission
      hasPurchaseMission
      hasReviewMission
      nearestRunStartAt
      contract {
        id
        endAt
        monthlyParticipationLimit
        currentUserParticipationCount
        remainingParticipationCount
      }
      steps {
        id
        stepOrder
        type
        title
        guide
        requirements
        notices
        proofType
        isRequired
        meta
        imageUrl
      }
      runs {
        id
        startAt
        endAt
        durationMinutes
        depositAmount
        prizeAmount
        note
        isActive
        participationCount
        maxParticipants
        currentParticipants
        isFull
        remainingSlots
      }
      createdAt
      updatedAt
    }
  }
`;
